// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zRY5VFm1yz4GjlCDdEVn{justify-content:flex-start;align-items:center;display:flex}.i7F8YeNh1Y0PXavuN2NE{flex-direction:column;justify-content:center;align-items:flex-start;display:flex}.KiupoZZjN902F7KEg1Lp{flex-direction:column;gap:16px;display:flex}.gBCZ2DLsWgQJCEtXODyZ{cursor:default;align-items:center;max-width:316px;height:40px;margin-left:auto;padding:8px 12px;display:flex}.gBCZ2DLsWgQJCEtXODyZ>:first-child{height:-webkit-fit-content;height:fit-content;padding:4px 0}.ZyA58rR6K6AazdSQxeL4{gap:8px;margin-left:16px;display:flex}.ZyA58rR6K6AazdSQxeL4 .hslp0hrN0h4MVV9ELQ6r{color:#0a5bff}.ZyA58rR6K6AazdSQxeL4 .KwRBq25Q4_4qi_j62LgH{color:#000}.ZyA58rR6K6AazdSQxeL4 .TM76ro3W7eAAbp108E5w{color:#0077b5}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `zRY5VFm1yz4GjlCDdEVn`,
	"description": `i7F8YeNh1Y0PXavuN2NE`,
	"linkSection": `KiupoZZjN902F7KEg1Lp`,
	"linkField": `gBCZ2DLsWgQJCEtXODyZ`,
	"socials": `ZyA58rR6K6AazdSQxeL4`,
	"facebook": `hslp0hrN0h4MVV9ELQ6r`,
	"twitter": `KwRBq25Q4_4qi_j62LgH`,
	"linkedin": `TM76ro3W7eAAbp108E5w`
};
export default ___CSS_LOADER_EXPORT___;
